import { ResolverWindowElementFormOptions } from '@newageerp/crm-ui'
import React, { Fragment } from 'react'
import JsonField from './Components/JsonField'

export default function ResolverEditFormCustomField(props: ResolverWindowElementFormOptions) {
  return (
    <Fragment>
      {props.name === 'EditFields/JsonField' && <JsonField fieldKey={props.fieldKey} />}
    </Fragment>
  )
}
